import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import React from "react";

const PeriodoSelected = ({ value, onChange ,className=''}) => {
  return (
    <FormControl fullWidth className={className}>
      <InputLabel id="demo-simple-select-label-periodo">Periodo</InputLabel>
      <Select
        size="small"
        labelId="demo-simple-select-label-periodo"
        id="demo-simple-select-periodo"
        value={value}
        label="Periodo"
        onChange={(event) => onChange(event.target.value)}
      >
        <MenuItem value={1}>Enero</MenuItem>
        <MenuItem value={2}>Febrero</MenuItem>
        <MenuItem value={3}>Marzo</MenuItem>
        <MenuItem value={4}>Abril</MenuItem>
        <MenuItem value={5}>Mayo</MenuItem>
        <MenuItem value={6}>Junio</MenuItem>
        <MenuItem value={7}>Julio</MenuItem>
        <MenuItem value={8}>Agosto</MenuItem>
        <MenuItem value={9}>Septiembre</MenuItem>
        <MenuItem value={10}>Octubre</MenuItem>
        <MenuItem value={11}>Noviembre</MenuItem>
        <MenuItem value={12}>Diciembre</MenuItem>
      </Select>
    </FormControl>
  );
};

export default PeriodoSelected;
